import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

/**
 * Small "Download the app" pill used across marketing pages. Mirrors the
 * Contact us pattern so the visual voice stays consistent. Always links
 * to `/download` (the alias `/install` also resolves to the same page).
 *
 * Props:
 * - variant: "outline" (default) or "solid" or "ghost"
 * - size: passed through to shadcn Button
 * - label: override the CTA copy (default: "Download the app")
 * - testId: data-testid; every placement should pass a unique one
 */
export default function DownloadPill({ variant = "outline", size = "default", label = "Download the app", testId = "download-pill", className = "" }) {
  return (
    <Link to="/download" data-testid={testId} className={className}>
      <Button variant={variant} size={size} className="rounded-full">
        <Download className="w-4 h-4 mr-2" /> {label}
      </Button>
    </Link>
  );
}
